import { render, staticRenderFns } from "./addcustomcaseHistory.vue?vue&type=template&id=32ea5a78&scoped=true"
import script from "./addcustomcaseHistory.vue?vue&type=script&lang=js"
export * from "./addcustomcaseHistory.vue?vue&type=script&lang=js"
import style0 from "./addcustomcaseHistory.vue?vue&type=style&index=0&id=32ea5a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea5a78",
  null
  
)

export default component.exports